import React from "react";
import { Flex, Image } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.svg";

type BrandProps = {
  centerLogo?: boolean;
  preview?: boolean;
  url?: string;
};

const Brand: React.FC<BrandProps> = (props: BrandProps) => {
  const { centerLogo = true, preview, url } = props;
  const { t } = useTranslation();
  return (
    <Flex justify={centerLogo ? "center" : "start"}>
      {preview ? (
        url ? (
          <Image src={url} width={150} height={80} preview={false} className="object-contain" />
        ) : (
          <Flex
            justify="center"
            align="center"
            className="w-[150px] h-[80px] border border-lineColor"
          >
            <Paragraph className="h2-medium text-[#AFBCC9]">
              {t("LOGO")}
            </Paragraph>
          </Flex>
        )
      ) : (
        url ? (
          <Image src={url} width={150} height={80} preview={false} className="object-contain"/>
        ) : (
          <Flex
            justify="center"
            align="center"
            className="w-[150px] h-[80px] p-4"
            style={{ backgroundColor: "#F5F7FA" }}
          >
            <Image src={logo} preview={false} />
          </Flex>
        )
      )}
    </Flex>
  );
};
export default Brand;
